import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {FrameworkHttpService} from '../framework/http/service';
import {ChasingPlanSettings, QARService, ReportEntity, ReportParticipationEntity, SORUserEntity, ApprovalRequestEntity} from '../services/qar.service';
import {UITableComponentHeader, UITableComponentOptions} from '../framework/ui/table';
import {AppUser, AppUserData} from '../framework/AppUser';
import {Chunker} from '../framework/chunker';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {take} from 'rxjs/operators';

@Component({
	selector: 'app-page-qar-report-chasing',
	templateUrl: 'qar-report-chasing.html',
	providers: [QARService]
})
export class PageQARReportChasingComponent implements OnInit {
	public self = this;

	constructor(public api: QARService, public user: AppUser, public _ngZone: NgZone) {

	}

	downloadAsExcelHeaders() {
		return [
			{label: 'User Name', id: 'userName'},
			{label: 'User Email', id: 'userEmail'},
			{label: 'Last Chased Date', id: 'LastChasedDate'},
			{label: 'Chased Count', id: 'ChasingCount'},
			{label: 'Comments', id: 'comments'},
		];
	}

	downloadAsExcelRowFormatter(headerId, currentValue, row) {
		console.log({headerId, currentValue, row});
		switch (headerId) {
			case 'userEmail':
				return row['SORUserApprover']['Email'] + ';';
			case 'userName':
				return row['SORUserApprover']['FirstName'] + ' ' + row['SORUserApprover']['LastName'];
			case 'comments':
				return row['ChasingNotes'];
			default:
				return row[headerId];
		}
		return '(' + headerId + ')';
	}

	@ViewChild('autosize') autosize: CdkTextareaAutosize;

	triggerResize() {
		// Wait for changes to be applied, then trigger textarea resize.
		this._ngZone.onStable.pipe(take(1))
			.subscribe(() => this.autosize.resizeToFitContent(true));
	}

	ngOnInit(): void {
		this.reports_init();
		this.requests.loading = true;
		this.api.retrieveApprovalRequestsToChase().then(r => {
			this.requests.loading = false;
			this.requests.chunker = new Chunker(r);
			console.log(this.requests.chunker);
		});
	}

	public reports = {
		loading: false,
		selected: null,
		selectedId: null,
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'name', label: 'Report', filterable: true},
			{id: 'year', label: 'Year', filterable: true},
			{id: 'statusId', label: 'Status', filterable: true},
			{id: 'opened', label: 'Date Opened'}
		],
	};

	public reports_select(report: ReportEntity) {
		this.reports.selectedId = report.Id;
		this.chasing_init();
	}

	public chasing = {
		sentEmail: {},
		chunker: new Chunker([]),
		count: 0,
		chunkedData: [],
		loading: false,
		canChase: false,
		tableHeaders: [
			{label: 'Approver First Name', filterable: true, idFunction: this.helper_idFunctionApproverFirstName},
			{label: 'Approver Last Name', filterable: true, idFunction: this.helper_idFunctionApproverLastName},
			{label: 'Approver Email', filterable: true, idFunction: this.helper_idFunctionApproverEmail},
			{label: 'Chased Count', filterable: true, id: 'ChasingCount'},
			{label: 'Last Chased Date', filterable: true, id: 'LastChasedDate', type: 'date'},
			{label: 'Send Email', filterable: false},
			{label: 'Comments', filterable: true, id: 'ChasingNotes'},
			{label: ''}
		],
		activeTextarea: {},
		savingComment: {},
		savingCommentTimeout: {},
	};

	public helper_idFunctionApproverFirstName(row: ReportParticipationEntity) {
		return row.SORUserOverridenApprover ? row.SORUserOverridenApprover.FirstName : row.SORUserApprover.FirstName;
	}

	public helper_idFunctionApproverLastName(row: ReportParticipationEntity) {
		return row.SORUserOverridenApprover ? row.SORUserOverridenApprover.LastName : row.SORUserApprover.LastName;
	}

	public helper_idFunctionApproverEmail(row: ReportParticipationEntity) {
		return row.SORUserOverridenApprover ? row.SORUserOverridenApprover.Email : row.SORUserApprover.Email;
	}

	public reports_init() {
		this.reports.loading = true;
		this.api.retrieveQARReportsForReportBrowser().then(r => {
			this.reports.loading = false;
			this.reports.chunker = new Chunker(r);
		});
	}

	chasing_init() {
		this.chasing.canChase = !this.user.hasGroup('AUDITORS');
		this.chasing.loading = true;
		this.api.retrieveQARReportsParticipationsForChasingForReportId(this.reports.selectedId).then(r => {
			this.chasing.chunker = new Chunker(r);
			this.chasing.loading = false;
			this.chasing.count = this.chasing.chunker.size;

			// set the email in red if email was sent today
			const dateToday = new Date();
			const y = dateToday.getFullYear();
			const month = (dateToday.getMonth() + 1);
			const date = (dateToday.getDate());
			let d = '' + date;
			let m = '' + month;
			if (month < 10) {
				m = '0' + month;
			}
			if (date < 10) {
				d = '0' + date;
			}
			const fulldate = y + '-' + m + '-' + d;
			for (const row of r) {
				if (row['LastChasedDate'] && row['LastChasedDate'].substring(0, 10) === fulldate) {
					this.chasing.sentEmail[row['Id']] = true;
				}
			}
		}, e => {
			if (e.status === 404) {
				alert('Sorry, no report open');
			} else {
				alert('Sorry, error' + e.status);
			}
		});
	}

	chasing_commentSave(participation) {
		this.chasing.savingComment[participation.Id] = true;
		this.api.saveReportParticipationChasingComment(participation.Id, participation.ChasingNotes).then(r => {
			this.chasing.savingComment[participation.Id] = false;
		});
	}


	public newEmail = {
		modalHidden: true,
		message: null,
		sending: false,
		who: '',
		important: false,
		copyAuditTeam: false,
		title: '',
		participationId: null,
		sendToOption: null,
		userName: null,
		managerName: null,
		participation: new ReportParticipationEntity()
	};

	public newEmail_open(participation: ReportParticipationEntity) {
		this.newEmail.title = 'Email reminder to ' + (participation.SORUserOverridenApprover ? participation.SORUserOverridenApprover.Email : participation.SORUserApprover.Email);
		this.newEmail.modalHidden = false;
		this.newEmail.participationId = participation.Id;
		this.newEmail.participation = participation;
		const user = participation.SORUserOverridenApprover ? participation.SORUserOverridenApprover : participation.SORUserApprover;
		this.newEmail.userName = user.FirstName + ' ' + user.LastName + ' ( ' + user.Office + ', ' + user.Country + ')';
		this.newEmail.managerName = user.Manager !== null ? user.Manager.FirstName + ' ' + user.Manager.LastName + ' (' + user.Manager.Office + ')' : 'no manager on record';
		this.newEmail.sendToOption = [
			{id: 1, value: '', name: 'User'},
			{id: 2, value: 'copy-to-manager', name: 'User + Copy Email to Manager'},
			{id: 3, value: 'manager', name: 'Manager'}
		];
		this.newEmail_updateForManager();
	}

	public newEmail_updateForManager() {
		if (this.newEmail.who === 'copy-to-manager') {
			this.newEmail.message = '(the report needs to be filled by ' + this.newEmail.participation.SORUserApprover.FirstName + ' ' + this.newEmail.participation.SORUserApprover.LastName + ')';
		} else {
			this.newEmail.message = '';
		}
	}


	public newEmail_send() {
		this.newEmail.sending = true;
		this.api.sendChasingEmail(this.newEmail.participationId, this.newEmail.message, this.newEmail.who, this.newEmail.important, this.newEmail.copyAuditTeam).then(r => {
			this.newEmail.sending = false;
			this.newEmail.modalHidden = true;
			// update
			const data = this.chasing.chunker.getOriginalData();
			for (const row of data) {
				if (row['Id'] === this.newEmail.participationId) {
					row.ChasingCount++;
					row.LastChasedDate = new Date();
				}
			}
			this.chasing.sentEmail[this.newEmail.participationId] = true;
		}, e => {
			this.newEmail.sending = false;
			if (e.status === 409) {
				alert('Sorry, this user has no email registered');
			} else {
				alert('Sorry, something went wrong : ' + e.status);
			}
		});
	}

	// 186177 User Story 186177: chasing for approval requests //
	public requests = {
		chunker: new Chunker([]),
		chunkedData: [],
		loading: false,
		tableHeaders: [
			{id: 'Type', label: 'Type', filterable: true, type: ''},
			{id: 'Reference', label: 'Reference', filterable: true},
			{id: 'CreatedDate', label: 'Date Created', filterable: false, type: 'date'},
			{id: 'SORUser', label: 'Approver Name', filterable: true, idFunction: this.helper_idFunctionSORUserName},
			{id: 'SORUser', label: 'Approver Email', filterable: true, idFunction: this.helper_idFunctionSORUserEmail},
			{id: 'StatusId', label: 'Status', filterable: true},
			{id: 'ChasingCount', label: 'Chased Count', filterable: true},
			{id: 'LastChasedDate', label: 'Last Chased Date', filterable: false},
			{id: 'Counter Signing', label: 'Counter Signing', filterable: true, type: 'dropdown', options: {choices: {na: 'N/A', pending: 'Pending', done: 'Done'}}, idFunction: this.helper_idFunctionCounterSigning},
			{id: 'SendEmail'},
			{id: 'Open'},
		]
	};

	public helper_idFunctionCounterSigning(ar: ApprovalRequestEntity) {
		return ar.NeedCountersigning ? (ar.StatusId === 'pending' ? 'pending' : 'done') : 'na';
	}

	public helper_idFunctionSORUserName(ar: ApprovalRequestEntity) {
		return ar.SORUser.FirstName + ' ' + ar.SORUser.LastName;
	}

	public helper_idFunctionSORUserEmail(ar: ApprovalRequestEntity) {
		return ar.SORUser.Email;
	}

	public newApprovalRequest = {
		modalHidden: true,
		message: null,
		sending: false,
		who: '',
		important: false,
		copyAuditTeam: false,
		title: '',
		approvalRequestId: null,
		sendToOption: null,
		userName: null,
		managerName: null,
		requests: new ApprovalRequestEntity()
	};

	public newApprovalRequest_open(requests: ApprovalRequestEntity) {
		this.newApprovalRequest.title = 'Email reminder to ' + (requests.SORUser ? requests.SORUser.Email : requests.SORUser.Email);
		this.newApprovalRequest.modalHidden = false;
		this.newApprovalRequest.approvalRequestId = requests.Id;
		this.newApprovalRequest.requests = requests;
		const user = requests.SORUser ? requests.SORUser : requests.SORUser;
		this.newApprovalRequest.userName = user.FirstName + ' ' + user.LastName + ' ( ' + user.Office + ', ' + user.Country + ')';
		this.newApprovalRequest.managerName = user.Manager !== null ? user.Manager.FirstName + ' ' + user.Manager.LastName + ' (' + user.Manager.Office + ')' : 'no manager on record';
		this.newApprovalRequest.sendToOption = [
			{id: 1, value: '', name: 'User'},
			{id: 2, value: 'copy-to-manager', name: 'User + Copy Email to Manager'},
			{id: 3, value: 'manager', name: 'Manager'}
		];
		this.newApprovalRequest_updateForManager();
	}

	public newApprovalRequest_updateForManager() {
		if (this.newApprovalRequest.who === 'copy-to-manager') {
			this.newApprovalRequest.message = '(the approval request needs to be filled by ' + this.newApprovalRequest.requests.SORUser.FirstName + ' ' + this.newApprovalRequest.requests.SORUser.LastName + ')';
		} else {
			this.newApprovalRequest.message = '';
		}
	}

	public newApprovalRequest_send() {
		this.newApprovalRequest.sending = true;
		this.api.sendApprovalRequestChasingEmail(this.newApprovalRequest.approvalRequestId, this.newApprovalRequest.message, this.newApprovalRequest.who, this.newApprovalRequest.important, this.newApprovalRequest.copyAuditTeam).then(r => {
			this.newApprovalRequest.sending = false;
			this.newApprovalRequest.modalHidden = true;
			// update
			const data = this.chasing.chunker.getOriginalData();
			for (const row of data) {
				if (row['Id'] === this.newEmail.participationId) {
					row.ChasingCount++;
					row.LastChasedDate = new Date();
				}
			}
			this.chasing.sentEmail[this.newEmail.participationId] = true;
		}, e => {
			this.newEmail.sending = false;
			if (e.status === 409) {
				alert('Sorry, this user has no email registered');
			} else {
				alert('Sorry, something went wrong : ' + e.status);
			}
		});
	}

	// End of Approval Request Chasing //
}
